const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		// ===================================
		//  GET VIDEOS FROM VIMEO
		// ===================================
		case "TRAINING_VIDEOS_ARE_LOADING":
			return {
				...state,
				isLoading: {
					...state.isLoading,
					[action.videoType]: 1
				}
			};
		case "TRAINING_VIDEOS_ERROR":
			return {
				...state,
				isLoading: {
					...state.isLoading,
					[action.videoType]: 0
				},
				errors: {
					...state.errors,
					[action.videoType]: action.error
				}
			};
		case "TRAINING_VIDEOS_SUCCESS":
			return {
				...state,
				isLoading: {
					...state.isLoading,
					[action.videoType]: 0
				},
				videos: {
					...state.videos,
					[action.videoType]: { ...action.data }
				}
			};

		// ===================================================================================
		//  SET WATCHED
		// ===================================================================================
		case "VIDEO_WATCHED_LOADING":
			return {
				...state,
				setWatchedLoading: 1
			};
		case "VIDEO_WATCHED_HAS_ERROR":
			return {
				...state,
				setWatchedLoading: 0,
				setWatchedError: action.error
			};
		case "VIDEO_WATCHED_SUCCESS":
			return {
				...state,
				setWatchedLoading: 0,
				setWatchedSuccess: action.data
			};

		// ===================================================================================
		//  GET VIDEO SURVEYS
		// ===================================================================================
		case "VIDEO_SUCCESS_LOADING":
			return {
				...state,
				setVideoSurveysLoading: 1
			};
		case "VIDEO_SUCCESS_HAS_ERROR":
			return {
				...state,
				setVideoSurveysLoading: 0,
				setVideoSurveysError: action.error
			};
		case "VIDEO_SURVEYS_SUCCESS":
			return {
				...state,
				setVideoSurveysLoading: 0,
				videoSurveys: action.data
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/trainingVideos.js